import React from "react";
import Button from "@material-ui/core/Button";
import { Dimensions } from "../../../utils/Data/dataTexts";
import { DimensionInput } from "../../../components/FormInputs/FormInputs";
import AddShipment from "../../../assets/Icons/add-shipper.png";
import RemoveShipment from "../../../assets/Icons/remove-shipper.png";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";

const Shipment = {
  width: "",
  height: "",
  length: "",
  weight: "",
  quantity: "",
  packaging: "",
  actualweight: 0,
  chargeableweight: 0,
  totalvolume: 0,
};

function ShipmentDetails({ ...props }) {
  return (
    <>
      <div className="StepContainer FormWidth">
        <div className="FormTitleContainer">
          <p className="FormQuestion">{i18n.t("steptwo.label")}</p>
        </div>
        {props.order.shipments.map((item, i) => {
          return (
            <React.Fragment key={i}>
              <div className="DimensionsInputContainer MarginHorizontal">
                {Dimensions.map((dimension) => {
                  return (
                    <DimensionInput
                      key={`${dimension.id}${i}`}
                      id={dimension.id}
                      label={dimension.label}
                      value={item[dimension.id]}
                      onChange={(event) =>
                        props.handleItemChange(event, i, "shipments")
                      }
                    />
                  );
                })}
              </div>
              <div className="FlexEnd FormWidth">
                <Button
                  className="AddShipper"
                  onClick={() => {
                    if (i === 0) {
                      props.addItem("shipments", Shipment);
                    } else props.removeItem("shipments", i);
                  }}
                >
                  <span
                    style={{ display: "inline-flex", alignItems: "center" }}
                  >
                    <img
                      src={i === 0 ? AddShipment : RemoveShipment}
                      alt="plus-sign"
                    />
                  </span>
                  {i === 0
                    ? i18n.t("steptwo.addpcs")
                    : i18n.t("steptwo.removepcs")}
                </Button>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      <div>
        <p className="ShipmentSummaryText">{`${i18n.t("steptwo.totalpcs")}: ${
          props.order.shipmentpcs
        } ${i18n.t("general.pcs")}`}</p>
        <p className="ShipmentSummaryText">{`${i18n.t(
          "steptwo.totalweight"
        )}: ${props.order.shipmentweight} ${i18n.t("general.kg")}`}</p>
        <p className="ShipmentSummaryText">{`${i18n.t(
          "steptwo.totalchargeableweight"
        )}: ${props.order.shipmentchargeableweight} ${i18n.t(
          "general.kg"
        )}`}</p>
      </div>
      <div className="NavigationContainer FormWidth">
        <Button
          onClick={() => props.handleBack()}
          className="TransparentWhite Medium"
        >
          {i18n.t("general.back")}
        </Button>
        <div className="ButtonContainer">
          <Button
            onClick={() => {
              if (props.order.regular === true) {
                props.handleNext();
              } else props.handleNext(2);
            }}
            className="TransparentWhite Medium"
          >
            {i18n.t("general.skip")}
          </Button>
          <Button
            onClick={() => {
              if (props.order.regular === true) {
                props.handleNext();
              } else props.handleNext(2);
            }}
            className="OldLace Medium"
          >
            {i18n.t("general.next")}
          </Button>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(ShipmentDetails);
